import React from 'react';
import { useStyles, StyledPagination } from './styles';

export default function ControlledPagination({
  total = 1,
  pageByProps,
  perPage = 12,
  loading = false,
  onChange = () => {},
}) {
  const classes = useStyles();

  // Calcula quantas páginas são necessárias
  const qntPages = Math.ceil(total / perPage);

  const handleChange = (event, value) => {
    onChange(value);
  };

  return (
    <>
      {/* Só renderiza se não estiver carregando e houver mais de 1 página */}
      {!loading && qntPages > 1 && (
        <div className={classes.root}>
          <StyledPagination
            size="small"
            variant="outlined"
            shape="rounded"
            color="primary"
            count={qntPages}
            page={pageByProps} // Valor sempre controlado via props
            onChange={handleChange}
          />
        </div>
      )}
    </>
  );
}
